import React, { Component } from 'react';

import { gql, graphql } from 'react-apollo';
import kebabCase from 'lodash/kebabCase';

import { ChipInput } from 'components';

const FeatureInput = ({ addFeature, onAdd, ...rest }) => {
  return (
    <ChipInput
      {...rest}
      onAdd={async ({ name, chips }) => {
        try {
          const result = await addFeature({
            variables: {
              label: name,
              slug: kebabCase(name),
            },
          });

          onAdd(result.data.createFeature);
        } catch (error) {
          console.error('error', error);
        }
      }}
    />
  );
};

const ADD_FEATURE_MUTATION = gql`
  mutation addFeature($label: String!, $slug: String!) {
    createFeature(label: $label, slug: $slug) {
      id
      label
      slug
    }
  }
`;

export default graphql(ADD_FEATURE_MUTATION, { name: 'addFeature' })(
  FeatureInput
);



// WEBPACK FOOTER //
// ./src/common/components/FeatureInput.js